import React from "react";
import PageNavHeader from "../PageNavHeader";
import aboutUs1 from "../../../../assets/about_us_1.png";
import aboutUs1Mobile from "../../../../assets/about_us_1_mobile.png";

const headingStyle = { fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "clamp(36px, 6vw, 64px)", lineHeight: "1.05", letterSpacing: "-0.04em", color: "#E7DFF0" };
const subtitleStyle = { fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "24px", lineHeight: "1.6", color: "#CCC3DA", maxWidth: "680px" };

const AboutUsNavHeader = () => (
  <PageNavHeader
    mobileAlign="left"
    afterContent={
      <div className="relative z-10 w-full px-4 md:px-16 lg:px-20 pb-0">
        <img src={aboutUs1Mobile} alt="beemz about us" className="block md:hidden w-full rounded-[24px] object-cover" />
        <img src={aboutUs1} alt="beemz about us" className="hidden md:block w-full rounded-[34px] object-cover" />
      </div>
    }
  >
    <h1 className="lowercase" style={headingStyle}>
      we change the way you do<br />
      <span style={{ color: "#9747FF" }}>restaurant and retail</span>
    </h1>
    <p className="mt-5 lowercase md:mx-auto" style={subtitleStyle}>
      we simplify the way you do restaurant and retail business
    </p>
  </PageNavHeader>
);

export default AboutUsNavHeader;
